import { render, staticRenderFns } from "./Objetivos.vue?vue&type=template&id=2357fb54&scoped=true&lang=pug&"
import script from "./Objetivos.vue?vue&type=script&lang=js&"
export * from "./Objetivos.vue?vue&type=script&lang=js&"
import style0 from "./Objetivos.styl?vue&type=style&index=0&id=2357fb54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2357fb54",
  null
  
)

export default component.exports